// src/components/lessons/renderers/ListRenderer.jsx
// Handles generic 'list' type (auto-detects ordered vs unordered)
import React, { useState } from 'react';

const ListRenderer = ({ block, isMobile }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const isOrdered = block.ordered || (block.items && block.items.some(item =>
    typeof item === 'string' && /^\d+\./.test(item.trim())
  ));

  const processText = (text) => {
    if (typeof text !== 'string') return text;
    const parts = text.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, index) => {
      return index % 2 === 1 ? (
        <strong key={index} style={{ fontWeight: '700', color: '#000000' }}>
          {part}
        </strong>
      ) : part;
    });
  };

  if (isOrdered) {
    return (
      <ol style={{
        listStyle: 'none',
        padding: 0,
        margin: isMobile ? '0.75rem 0' : '1rem 0',
        counterReset: 'item'
      }}>
        {block.items.map((item, i) => (
          <li
            key={i}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: isMobile ? '0.75rem' : '1rem',
              marginBottom: isMobile ? '0.625rem' : '1rem',
              color: '#000000',
              lineHeight: '1.7',
              fontSize: isMobile ? '0.95rem' : '1rem',
              counterIncrement: 'item',
              padding: '0.75rem',
              marginLeft: '-0.75rem',
              marginRight: '-0.75rem',
              borderRadius: '0.5rem',
              background: hoveredIndex === i ? '#F9FAFB' : 'transparent',
              transition: 'all 0.2s ease',
              cursor: 'default',
              opacity: hoveredIndex === i ? 1 : 0.9
            }}
            onMouseEnter={() => setHoveredIndex(i)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <span style={{
              fontWeight: '700',
              fontSize: isMobile ? '1rem' : '1.125rem',
              color: hoveredIndex === i ? '#000000' : '#3A86FF',
              minWidth: isMobile ? '1.25rem' : '1.5rem',
              transition: 'color 0.2s ease'
            }}>
              {i + 1}.
            </span>
            <span style={{ flex: 1 }}>
              {processText(item)}
            </span>
            {hoveredIndex === i && (
              <div style={{
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                background: '#3A86FF',
                marginTop: '0.5rem',
                flexShrink: 0
              }} />
            )}
          </li>
        ))}
      </ol>
    );
  }

  return (
    <ul style={{
      listStyle: 'none',
      padding: 0,
      margin: isMobile ? '0.75rem 0' : '1rem 0'
    }}>
      {block.items.map((item, i) => (
        <li
          key={i}
          style={{
            color: '#000000',
            lineHeight: isMobile ? '1.6' : '1.7',
            marginBottom: isMobile ? '0.5rem' : '0.75rem',
            fontSize: isMobile ? '0.9375rem' : '1rem',
            display: 'flex',
            alignItems: 'flex-start',
            gap: isMobile ? '0.5rem' : '0.75rem',
            padding: isMobile ? '0.375rem' : '0.5rem',
            marginLeft: isMobile ? '-0.375rem' : '-0.5rem',
            marginRight: isMobile ? '-0.375rem' : '-0.5rem',
            borderRadius: '0.5rem',
            background: hoveredIndex === i ? '#F9FAFB' : 'transparent',
            transition: 'all 0.2s ease',
            cursor: 'default',
            opacity: hoveredIndex === i ? 1 : 0.85
          }}
          onMouseEnter={() => setHoveredIndex(i)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <span style={{
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            background: hoveredIndex === i ? '#000000' : '#3A86FF',
            marginTop: '0.5rem',
            flexShrink: 0,
            transition: 'all 0.2s ease',
            transform: hoveredIndex === i ? 'scale(1.3)' : 'scale(1)'
          }} />
          <span style={{ flex: 1 }}>
            {processText(item)}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default ListRenderer;